import { render, staticRenderFns } from "./createExternal.vue?vue&type=template&id=124a2441&scoped=true&"
import script from "./createExternal.vue?vue&type=script&lang=js&"
export * from "./createExternal.vue?vue&type=script&lang=js&"
import style0 from "./createExternal.vue?vue&type=style&index=0&id=124a2441&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124a2441",
  null
  
)

export default component.exports